import { observer } from 'mobx-react'
import React from 'react'
import i18n from 'i18next'

import Modal from '../../UniformComponents/Modal'
import Panel from '../../UniformComponents/Panel'
import Typography from '../../UniformComponents/Typography'
import HoverInfo from '../../UniformComponents/HoverInfo'

import './surveyLicenceModal.scss'
import Anchor from '../../UniformComponents/Anchor'

const renderDescription = (licenceType = 'pro') => (
    <div className="description">
        <ul>
            {[...Array(3)].map((_, i) => (
                <li key={i}>
                    <Typography type="tiniest">
                        {i18n.t(`surveyLicenceModal.${licenceType}.description.${i + 1}`)}
                    </Typography>
                </li>
            ))}
        </ul>
    </div>
)

const SurveyLicenceModal = ({ store }) => (
    <Modal
        show={store.surveyLicenceModalVisible}
        onClose={store.closeSurveyLicenceModal}
        style={{ width: 500 }}
    >
        <div className="licence-modal-title-container">
            <Typography type="h2">
                {i18n.t('surveyLicenceModal.title')}
            </Typography>
        </div>
        <br />
        <Typography>
            {i18n.t('surveyLicenceModal.subtitle.1')}
        </Typography>
        <Typography color="grey" cssClass="italic">
            {i18n.t('surveyLicenceModal.subtitle.2')}
        </Typography>

        <br />

        <br />

        <div className="licence-option-container">
            <Panel
                cssClass={`licence-option pro-option ${store.selectedSurveyLicense === 'pro' ? 'selected-licence' : ''}`}
                onClick={() => store.selectSurveyLicense('pro')}
            >
                <div className="icon-container green-container">
                    <i className="fal fa-clipboard-list clipboard-icon" />

                    <span className="pro-icon">
                        PRO
                    </span>
                </div>
                <br />
                <Typography type="h4">
                    {i18n.t('surveyLicenceModal.proOption')}
                </Typography>
                {renderDescription()}
            </Panel>

            <Panel
                cssClass={`licence-option lite-option ${store.selectedSurveyLicense === 'rapid' ? 'selected-licence' : ''}`}
                onClick={() => store.selectSurveyLicense('rapid')}
            >
                <div className="icon-container purple-container">
                    <i className="fal fa-clipboard-list-check clipboard-icon" />

                    <i className="fas fa-feather feather-icon" />
                </div>
                <br />
                <Typography type="h4">
                    {i18n.t('surveyLicenceModal.liteOption')}
                </Typography>
                {renderDescription('lite')}
            </Panel>
        </div>
        <div className="footer">
            <p>{i18n.t('surveyLicenceModal.footer')}</p>
            <Anchor isExternal target="_blank" href="https://kb.explori.com/knowledge/explori-lite">
                <i className="info-icon fa-solid fa-circle-question" />
            </Anchor>
        </div>
    </Modal>
)

export default observer(SurveyLicenceModal)
